import { render, staticRenderFns } from "./normalroles.vue?vue&type=template&id=629dab9f"
import script from "./normalroles.vue?vue&type=script&lang=js"
export * from "./normalroles.vue?vue&type=script&lang=js"
import style0 from "./normalroles.vue?vue&type=style&index=0&id=629dab9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports